import React from 'react';
import TextBlock from '../Components/TextBlock';

const L4 = (props) => {
  return (
    <React.Fragment>
      <TextBlock name='Зміна місцезнаходження'>
        <section className="s-text">
        Для реєстрації нової юридичної адреси нам знадобиться: <br/>
          - інформація про ваше підприємство (назва, код ЄДРПОУ); <br/> 
          - інформація про засновників і керівника (паспортні дані та ідентифікаційні коди);<br/>
          - нотаріально посвідчений протокол загальних зборів (протокол готують наші спеціалісти);<br/>
        </section> 
        <section className="s-textb">
          Строк виконання – 2-3 робочі дні<br/>
          Якщо адреса не прописана в поточній редакції статуту, вартість наших послуг –  1000 грн.<br/>
          Якщо адреса прописана в поточній редакції статуту, вартість наших послуг –  1200 грн.<br/>
          Додатково сплачуються послуги нотаріуса (залежить від кількості засновників) і державний збір (30% від прожиткового мінімуму для працездатних осіб).
        </section>  
      </TextBlock>   
    </React.Fragment>
  );
}

const L5 = (props) => {
  return (
    <TextBlock name='Зміна керівника або відомостей про керівника'>
      <section className="s-text">
      Для внесення змін у відомості про керівника, що містяться в ЄДР, нам знадобиться:<br/> 
      - інформація про ваше підприємство (назва, код ЄДРПОУ); <br/> 
        - інформація про засновників і керівника (паспортні дані та ідентифікаційні коди); <br/> 
        - нотаріально посвідчений протокол загальних зборів (протокол готують наші спеціалісти);<br/>
      </section> 
      <section className="s-textb">
        Строк виконання – 2-3 робочі дні <br/> 
        Вартість – 1500грн. <br/>
       Додатково сплачуються послуги нотаріуса (залежить від кількості засновників) і державний збір (30% від прожиткового мінімуму для працездатних осіб).

      </section> 
      
    </TextBlock>
  );
}

const L6 = (props) => {
  return (
    <TextBlock name='Зміна складу засновників'>
      <section className="s-text">
        Для зміни складу засновників нам знадобиться:<br/> 
        - інформація про ваше підприємство (назва, код ЄДРПОУ); <br/> 
        - інформація про засновників і керівника (паспортні дані та ідентифікаційні коди);<br/> 

      </section> 
      <section className="s-textb">
        Строк виконання 3-5 робочих днів <br/> 
        Вартість наших послуг – 3000 гривень. <br/> 
        Додатково сплачуються послуги нотаріуса (залежить від кількості засновників) і державний збір (30% від прожиткового мінімуму для працездатних осіб).
      </section>  
    </TextBlock>
  );
}

const L7 = (props) => {
  return (
    <TextBlock name='Зміна найменування'>
      <section className="s-text">
        Для зміни складу засновників нам знадобиться:<br/> 
        - інформація про ваше підприємство (назва, код ЄДРПОУ); <br/> 
        - інформація про засновників і керівника (паспортні дані та ідентифікаційні коди);      </section> 
      <section className="s-textb">
        Строк виконання 2-3 робочі дні <br/> 
        Вартість наших послуг – 1500 гривень. <br/> 
        Додатково сплачуються послуги нотаріуса (залежить від кількості засновників) і державний збір (30% від прожиткового мінімуму для працездатних осіб).

      </section>  
    </TextBlock>
  );
}

const L8 = (props) => {
  return (
    <TextBlock name='Зміна розміру статутного капіталу '>
    <section className="s-text">
      Для зміни складу засновників нам знадобиться:<br/> 
      - інформація про ваше підприємство (назва, код ЄДРПОУ); <br/> 
      - інформація про засновників і керівника (паспортні дані та ідентифікаційні коди);      </section> 
    <section className="s-textb">
      Строк виконання 2-3 робочі дні <br/> 
      Вартість наших послуг – 2000 гривень. <br/> 
      Додатково сплачуються послуги нотаріуса (залежить від кількості засновників) і державний збір (30% від прожиткового мінімуму для працездатних осіб).
      </section>  
    </TextBlock>
  );
}

const L9 = (props) => {
  return (
    <TextBlock name='Зміна КВЕД'>
      <section className="s-text">
        Для зміни складу засновників нам знадобиться:<br/>
        - інформація про ваше підприємство (назва, код ЄДРПОУ); <br/> 
        - інформація про засновників і керівника (паспортні дані та ідентифікаційні коди); <br/>
        - КВЕДи, що змінюються <br/>
    </section> 
      <section className="s-textb">
        Строк виконання 2-3 робочі дні <br/> 
        Вартість наших послуг – 1500 гривень. <br/> 
        Додатково сплачуються послуги нотаріуса (залежить від кількості засновників) і державний збір (30% від прожиткового мінімуму для працездатних осіб).
      </section>  
    </TextBlock>
  );
}

const L10 = (props) => {
  return (
    <TextBlock name='Зміна контактної інформації (телефон, електронну пошту)'>
      <section className="s-text">
       Для зміни контактної інформації, що міститься в ЄДР нам знадобиться:<br/>
        - інформація про ваше підприємство (назва, код ЄДРПОУ); <br/> 
        - інформація про керівника (паспортні дані та ідентифікаційні коди); <br/>
        - інформація, що змінюється <br/>
      </section> 
      <section className="s-textb">
        Строк виконання 1-2 робочі дні <br/> 
        Вартість наших послуг – 1500 гривень. <br/> 
        Додатково сплачуються послуги нотаріуса (залежить від кількості засновників) і державний збір (30% від прожиткового мінімуму для працездатних осіб).
      </section>  
    </TextBlock>
  );
}

const L11 = (props) => {
  return (
    <TextBlock name='Внесення змін до статуту'>
      <section className="s-text">
        Для реєстрації статуту в новій редакції знадобиться:<br/>
        - інформація про ваше підприємство (назва, код ЄДРПОУ); <br/> 
        - інформація про засновників і керівника (паспортні дані та ідентифікаційні коди); <br/>
      </section> 
      <section className="s-textb">
        Строк виконання 2-3 робочі дні <br/> 
        Вартість наших послуг – 1500 гривень. <br/> 
        Додатково сплачуються послуги нотаріуса (залежить від кількості засновників) і державний збір (30% від прожиткового мінімуму для працездатних осіб).

      </section>  
    </TextBlock>
  );
}

export { L4, L5, L6, L7, L8, L9, L10, L11 };


// WEBPACK FOOTER //
// ./src/Page/L4-L11.jsx